/**
 * 常量配置文件
 * 定义游戏中使用的所有常量
 */

/** 默认网格大小 */
export const GRID_SIZE = 4;

/** 单元格大小（像素） */
export const CELL_SIZE = 100;

/** 单元格间隙（像素） */
export const CELL_GAP = 10;

/** 动画持续时间（毫秒） */
export const ANIMATION_DURATION = 200;

/** 初始方块数量 */
export const START_TILES = 2;

/** 胜利目标数值 */
export const WIN_VALUE = 2048;

/** 新方块值为2的概率 */
export const TILE_2_PROBABILITY = 0.9;

/** 方块颜色配置 */
export const TILE_COLORS: Record<number, string> = {
  2: '#eee4da',
  4: '#ede0c8',
  8: '#f2b179',
  16: '#f59563',
  32: '#f67c5f',
  64: '#f65e3b',
  128: '#edcf72',
  256: '#edcc61',
  512: '#edc850',
  1024: '#edc53f',
  2048: '#edc22e',
  4096: '#3c3a32',
};

/** 方块文字颜色配置 */
export const TILE_TEXT_COLORS: Record<number, string> = {
  2: '#776e65',
  4: '#776e65',
  8: '#f9f6f2',
  16: '#f9f6f2',
  32: '#f9f6f2',
  64: '#f9f6f2',
  128: '#f9f6f2',
  256: '#f9f6f2',
  512: '#f9f6f2',
  1024: '#f9f6f2',
  2048: '#f9f6f2',
  4096: '#f9f6f2',
};

/** 键盘按键映射 */
export const KEY_CODES = {
  UP: ['ArrowUp', 'w', 'W'],
  DOWN: ['ArrowDown', 's', 'S'],
  LEFT: ['ArrowLeft', 'a', 'A'],
  RIGHT: ['ArrowRight', 'd', 'D'],
} as const;

/** 本地存储键名 */
export const STORAGE_KEYS = {
  GAME_STATE: 'game2048_state',
  BEST_SCORE: 'game2048_best_score',
} as const;
